<div class="action-form" [class.is-submitted]="submitted">

  <!-- Header -->
  <div class="form-header">
    <mat-icon class="form-icon">{{ formDef.icon }}</mat-icon>
    <span class="form-title">{{ formDef.title }}</span>
    @if (submitted) {
      <span class="submitted-badge">
        <mat-icon>check_circle</mat-icon> Submitted
      </span>
    }
  </div>

  <!-- Fields -->
  <div class="form-fields">
    @for (field of formDef.fields; track trackByKey($index, field)) {
      <div class="form-field" [class.has-error]="errors[field.key]">
        <label [for]="'af-' + field.key">
          {{ field.label }}
          @if (field.required) { <span class="required">*</span> }
        </label>

        @if (field.key === 'project_name') {
          <div class="project-badge">
            <mat-icon class="project-badge-icon">folder</mat-icon>
            <span class="project-badge-name">{{ values[field.key] || '—' }}</span>
            <mat-icon class="project-badge-lock">lock</mat-icon>
          </div>
        } @else if (field.type === 'select') {
          <select
            [id]="'af-' + field.key"
            [(ngModel)]="values[field.key]"
            [disabled]="submitted"
          >
            <option value="">— select —</option>
            @for (opt of field.options; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        } @else if (field.type === 'textarea') {
          <textarea
            [id]="'af-' + field.key"
            [(ngModel)]="values[field.key]"
            [placeholder]="field.placeholder ?? ''"
            [disabled]="submitted"
            rows="2"
          ></textarea>
        } @else {
          <input
            [id]="'af-' + field.key"
            [type]="field.type"
            [(ngModel)]="values[field.key]"
            [placeholder]="field.placeholder ?? ''"
            [disabled]="submitted"
          />
        }

        @if (errors[field.key]) {
          <span class="error-msg">This field is required.</span>
        }
      </div>
    }
  </div>

  <!-- Submit -->
  @if (!submitted) {
    <div class="form-footer">
      <button class="submit-btn" (click)="submit()">
        <mat-icon>send</mat-icon>
        Submit
      </button>
    </div>
  }

</div>
